module.exports = __webpack_public_path__ + "static/media/news.2b0ab37e.psd";